import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import GeoblockActiveRules from './GeoblockActiveRules';
import { EMPTY_GEOBLOCK } from './GeoblockConstants';
import GeoblockDefaultAvailability from './GeoblockDefaultAvailability';
import GeoblockRuleBuilder from './GeoblockRuleBuilder';

type Props = {
  name: string;
};

const Geoblock = ({ name }: Props) => {
  const [initialized, setInitialized] = useState(false);
  const { getValues, setValue } = useFormContext();

  useEffect(() => {
    // Initialize geoblock value if not set
    const currentValue = getValues(name);

    if (!currentValue) {
      setValue(name, EMPTY_GEOBLOCK);
    }
    setInitialized(true);
  }, [getValues, setValue, name]);

  if (!initialized) {
    return <div>Loading geoblock...</div>;
  }

  return (
    <div className="geoblock">
      <GeoblockDefaultAvailability name={name} />

      <div className="geoblock-columns">
        <div className="geoblock-rule-builder">
          <GeoblockRuleBuilder name={name} />
        </div>
        <div className="geoblock-active-rules">
          <GeoblockActiveRules name={name} />
        </div>
      </div>
    </div>
  );
};

export default Geoblock;
